<div class="p-seatmap">
  <div class="p-seatmap__container">
    <div class="p-seatmap__title">
      <!-- 機種コード -->
      <span class="p-seatmap__title-num">{{ displayTargetSegment?.aircraftCode }}</span>
    </div>
    <!-- 表示階切替 -->
    <div *ngIf="isExistUpper" class="p-seatmap__tab-list" role="tablist">
      <button
        class="p-seatmap__tab-list-item"
        [class.is-current]="isMainDeck()"
        id="tab1"
        role="tab"
        [attr.aria-selected]="isMainDeck()"
        aria-controls="panel-1"
        tabindex="{{ isMainDeck() ? 0 : -1 }}"
        innerHTML="{{ 'label.floor1Butoon' | staticMsg }}"
        (click)="selectDeckType('main')"
        (keydown)="switchTab($event)"
        [disabled]="!isExistMain"
      ></button>
      <button
        class="p-seatmap__tab-list-item"
        [class.is-current]="!isMainDeck()"
        id="tab2"
        role="tab"
        [attr.aria-selected]="!isMainDeck()"
        aria-controls="panel-2"
        tabindex="{{ !isMainDeck() ? 0 : -1 }}"
        innerHTML="{{ 'label.floor2Butoon' | staticMsg }}"
        (click)="selectDeckType('upper')"
        (keydown)="switchTab($event)"
      ></button>
    </div>

    <div class="p-seatmap__tab-body">
      <!-- デッキ情報 -->
      <div
        *ngFor="let deck of seatmapResponse?.data?.seatmaps?.decks; index as i"
        class="p-seatmap__tab-container"
        [class.is-current]="deck.deckType === getCurrentDeckType()"
        id="panel-{{ i + 1 }}"
        role="tabpanel"
        attr.aria-labelledby="tab{{ i + 1 }}"
        tabindex="0"
      >
        <div
          class="p-seatmap__seatmap"
          [class.p-seatmap__seatmap--eco]="this.getSeatDesignName() === 'eco'"
          [class.p-seatmap__seatmap--ecoPremium]="this.getSeatDesignName() === 'ecoPremium'"
          [class.p-seatmap__seatmap--business]="this.getSeatDesignName() === 'business'"
          [class.p-seatmap__seatmap--first]="this.getSeatDesignName() === 'first'"
        >
          <!-- 行情報 -->
          <ng-container *ngFor="let row of deck.seats.rows; index as j">
            <!-- バシネット -->
            <div
              class="p-seatmap__row"
              [class.p-seatmap__row--has-wing]="row?.rowFacilities?.wings?.left || row?.rowFacilities?.wings?.right"
              *ngIf="
                row.rowType === 'seat' &&
                row?.isContainedBassinetSeat &&
                this.displayTargetSegment?.operatingAirlineCode === this.appConstants.CARRIER.TWO_LETTER
              "
            >
              <!-- 左翼 -->
              <span
                *ngIf="row?.rowFacilities?.wings?.left"
                class="p-seatmap__wing-left"
                [class.p-seatmap__wing-left--start]="isLeftWingsStart(deck, j)"
                ><span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.wing' | staticMsg }}"></span
              ></span>
              <!-- 列を繰り返し -->
              <ng-container *ngFor="let column of row?.columns">
                <ng-container *ngIf="!!column">
                  <div class="p-seatmap__col" *ngIf="column.columnType !== 'aisle'">
                    <!-- バシネット -->
                    <div
                      *ngIf="isBassinetSeat(column.seatCharacteristicsCodes)"
                      class="p-seatmap__facility p-seatmap__facility--bg-white"
                    >
                      <img
                        src="assets/images/seatmap_bassinet.svg"
                        width="24"
                        height="24"
                        alt="{{ 'm_static_message-label.bassinetSeat' | staticMsg }}"
                      />
                    </div>
                    <!-- バシネット以外 -->
                    <div
                      *ngIf="!isBassinetSeat(column.seatCharacteristicsCodes)"
                      class="p-seatmap__empty"
                      [class.p-seatmap__empty--2col]="false"
                      [class.p-seatmap__empty--3col]="false"
                      [class.p-seatmap__empty--4col]="false"
                    ></div>
                  </div>
                  <!-- 通路列 -->
                  <div *ngIf="column.columnType === 'aisle'" class="p-seatmap__aisle">
                    <span class="u-visually-hidden" innerHTML="{{ 'label.passage' | staticMsg }}"></span>
                  </div>
                </ng-container>
              </ng-container>
              <!-- 右翼 -->
              <span
                *ngIf="row?.rowFacilities?.wings?.right"
                class="p-seatmap__wing-right"
                [class.p-seatmap__wing-right--start]="isRightWingsStart(deck, j)"
                ><span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.wing' | staticMsg }}"></span
              ></span>
            </div>

            <!-- バシネット以外 -->
            <div
              class="p-seatmap__row"
              [class.p-seatmap__row--has-wing]="row?.rowFacilities?.wings?.left || row?.rowFacilities?.wings?.right"
            >
              <!-- 左翼 -->
              <span
                *ngIf="row?.rowFacilities?.wings?.left"
                class="p-seatmap__wing-left"
                [class.p-seatmap__wing-left--start]="isLeftWingsStart(deck, j)"
                ><span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.wing' | staticMsg }}"></span
              ></span>

              <!-- 行番号 -->
              <span *ngIf="row?.rowNumber && row.rowType === 'seat'" class="p-seatmap__row-num">
                <span innerHTML="{{ 'reader.columnNumber.n' | staticMsg : { '0': row?.rowNumber } }}"></span>
              </span>

              <!-- 左非常口 -->
              <span
                *ngIf="row?.rowFacilities?.emergencyExits?.left"
                class="p-seatmap__emergency-exit p-seatmap__emergency-exit--left"
                ><span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.exit' | staticMsg }}"></span
              ></span>

              <!-- ヘッダ情報 -->
              <ng-container *ngIf="row?.rowType === 'header'">
                <span class="u-visually-hidden" innerHTML="{{ 'reader.seatColumnNumber' | staticMsg }}"></span>
                <span class="u-visually-hidden" innerHTML="{{ 'reader.seatCaption' | staticMsg }}"></span>
                <span class="u-visually-hidden" innerHTML="{{ 'reader.columnNumber' | staticMsg }}"></span>
                <ng-container *ngFor="let column of deck.columns">
                  <!-- 列番号 -->
                  <div *ngIf="!column.isAisle" class="p-seatmap__col">
                    {{ column.columnNumber }}
                  </div>
                  <!-- 通路 -->
                  <div *ngIf="column.isAisle" class="p-seatmap__col-aisle">
                    <img
                      src="{{ this.appConstants.IMG.R01_P070_S01_U__SEATMAP__SEATMAP_AISLE_SHORT }}"
                      alt="{{ 'label.passage' | staticMsg }}"
                      width="6"
                      height="12"
                    />
                  </div>
                </ng-container>
              </ng-container>

              <!-- 設備情報 -->
              <ng-container *ngIf="row?.rowType === 'facility'">
                <span class="u-visually-hidden" innerHTML="{{ 'reader.facility' | staticMsg }}"></span>
                <!-- 左設備 -->
                <div class="p-seatmap__col p-seatmap__col--{{ getNumberOfLeftColumns(deck) }}col">
                  <ng-container *ngIf="!!row?.rowFacilities?.leftFacilityCodes">
                    <asw-seatmap-facility
                      [codes]="row?.rowFacilities?.leftFacilityCodes"
                      [numberOfColumn]="getNumberOfLeftColumns(deck)"
                    ></asw-seatmap-facility>
                  </ng-container>
                </div>

                <!-- 通路1 -->
                <div class="p-seatmap__aisle">
                  <span class="u-visually-hidden" innerHTML="{{ 'label.passage' | staticMsg }}"></span>
                </div>

                <ng-container *ngIf="deck.numberOfAisle === 2">
                  <!-- 中央設備 -->
                  <div class="p-seatmap__col p-seatmap__col--{{ getNumberOfCenterColumns(deck) }}col">
                    <ng-container *ngIf="!!row?.rowFacilities?.centerFacilityCodes">
                      <asw-seatmap-facility
                        [codes]="row?.rowFacilities?.centerFacilityCodes"
                        [numberOfColumn]="getNumberOfCenterColumns(deck)"
                      ></asw-seatmap-facility>
                    </ng-container>
                  </div>

                  <!-- 通路2（通路が二つある場合のみ） -->
                  <div class="p-seatmap__aisle">
                    <span class="u-visually-hidden" innerHTML="{{ 'label.passage' | staticMsg }}"></span>
                  </div>
                </ng-container>

                <!-- 右設備 -->
                <div class="p-seatmap__col p-seatmap__col--{{ getNumberOfRightColumns(deck) }}col">
                  <asw-seatmap-facility
                    *ngIf="row?.rowFacilities?.rightFacilityCodes?.length"
                    [codes]="row?.rowFacilities?.rightFacilityCodes"
                    [numberOfColumn]="getNumberOfRightColumns(deck)"
                  ></asw-seatmap-facility>
                </div>
              </ng-container>

              <!-- パーティション情報 -->
              <ng-container *ngIf="row?.rowType === 'partition'">
                <ng-container
                  *ngFor="
                    let column of this.getPartitionRowColumns(deck.deckType, deck.numberOfAisle, row.rowFacilities)
                  "
                >
                  <!-- パーティション -->
                  <div *ngIf="column.columnType === 'partition'" class="p-seatmap__col">
                    <div class="p-seatmap__partition">
                      <span class="u-visually-hidden" innerHTML="{{ 'label.partition' | staticMsg }}"></span>
                    </div>
                  </div>

                  <!-- 通路 -->
                  <div *ngIf="column.columnType === 'aisle'" class="p-seatmap__aisle">
                    <span class="u-visually-hidden" innerHTML="{{ 'label.passage' | staticMsg }}"></span>
                  </div>

                  <!-- 何も配置しない -->
                  <div *ngIf="column.columnType === ''" class="p-seatmap__col">
                    <div class="p-seatmap__partition--empty"></div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- 座席情報 -->
              <ng-container *ngIf="row?.rowType === 'seat'">
                <ng-container *ngFor="let column of row?.columns">
                  <ng-container *ngIf="!!column">
                    <!--
                    複数列の座席（カウチ席・設備）
                  -->
                    <div
                      *ngIf="false"
                      class="p-seatmap__col"
                      [class.p-seatmap__col--3col]="isStartOfThreeColumnCouchSeat(column)"
                      [class.p-seatmap__col--4col]="isStartOfFourColumnCouchSeat(column)"
                      [aswVerticalSlidePer]="getCouchRearMisalignment(row, column)"
                      [aswHorizontalSlidePer]="getCouchSideMisalignment(row, column)"
                    >
                      <span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.anaCouchii' | staticMsg }}"></span>
                      <asw-seatmap-couch-seat
                        [isThreeColumnCouchSeat]="isStartOfThreeColumnCouchSeat(column)"
                        [seatNumber]="getCouchSeatNumber(column.seatNumber)"
                        [displayTargetSegmentId]="displayTargetSegmentId"
                        [passengerIdList]="passengerIdList"
                        [selectedSeatInfoList]="selectedSeatInfoList"
                        [isLeftSide]="isLeftSide(deck, column.seatNumber)"
                        [isChangeRestrictedAllSeat]="isChangeRestrictedAllSeat"
                        [selectingPassengerId]="selectingPassengerId"
                        (clickSeat)="onClickSeat($event)"
                      ></asw-seatmap-couch-seat>
                    </div>

                    <!-- パーティション -->
                    <div
                      *ngIf="column.columnType === 'partition'"
                      class="p-seatmap__col p-seatmap__partition_height"
                      [aswVerticalSlidePer]="column.correction ? column.correction.rearMisalignment : 0"
                      [aswHorizontalSlidePer]="column.correction ? column.correction.sideMisalignment : 0"
                    >
                      <div class="p-seatmap__partition">
                        <span class="u-visually-hidden" innerHTML="{{ 'label.partition' | staticMsg }}"></span>
                      </div>
                    </div>

                    <!-- 単一列の座席 -->
                    <div
                      *ngIf="column.columnType === 'facility' || (column.columnType === 'seat' && !isCouchSeat(column))"
                      class="p-seatmap__col"
                      [aswVerticalSlidePer]="column.correction.rearMisalignment"
                      [aswHorizontalSlidePer]="column.correction.sideMisalignment"
                    >
                      <!-- 座席情報：設備 -->
                      <asw-seatmap-facility
                        *ngIf="column.columnType === 'facility' && !!column.facilityCode"
                        [codes]="[column.facilityCode]"
                        [numberOfColumn]="1"
                      ></asw-seatmap-facility>

                      <!-- 座席情報：座席 -->
                      <asw-seatmap-seat
                        *ngIf="column.columnType === 'seat'"
                        [seatNumber]="column.seatNumber"
                        [isContainedRearFacingSeat]="seatmapResponse?.data?.seatmaps?.isCotaninedRearFacingSeat"
                        [isChargeableAsrSeat]="column.isChargeableAsrSeat"
                        [seatCharacteristicsCodes]="column.seatCharacteristicsCodes"
                        [seatAvailabilityStatus]="column.seatAvailabilityStatus"
                        [selectedSeatInfoList]="selectedSeatInfoList"
                        [displayTargetSegmentId]="displayTargetSegmentId"
                        [isInformative]="isInformative"
                        [isInfantOnSeat]="column.isInfantSeated"
                        [isChangeRestrictedAllSeat]="isChangeRestrictedAllSeat"
                        (clickSeat)="onClickSeat($event)"
                      ></asw-seatmap-seat>
                    </div>

                    <!-- 何も配置しない列 -->
                    <div
                      *ngIf="
                        !(column.columnType === 'facility') &&
                        !(column.columnType === 'seat') &&
                        !(column.columnType === 'aisle') &&
                        !(column.columnType === 'partition')
                      "
                      class="p-seatmap__col"
                      [class.p-seatmap__col--2col]="false"
                      [class.p-seatmap__col--3col]="false"
                      [class.p-seatmap__col--4col]="false"
                      [aswVerticalSlidePer]="!!column.correction ? column.correction.rearMisalignment : 0"
                      [aswHorizontalSlidePer]="!!column.correction ? column.correction.sideMisalignment : 0"
                    >
                      <div
                        class="p-seatmap__empty"
                        [class.p-seatmap__empty--2col]="false"
                        [class.p-seatmap__empty--3col]="false"
                        [class.p-seatmap__empty--4col]="false"
                      ></div>
                    </div>

                    <!-- 通路列 -->
                    <div *ngIf="column.columnType === 'aisle'" class="p-seatmap__aisle">
                      <span class="u-visually-hidden" innerHTML="{{ 'label.passage' | staticMsg }}"></span>
                    </div>
                  </ng-container>
                  <div *ngIf="!column" class="p-seatmap__col">
                    <div
                      class="p-seatmap__empty"
                      [class.p-seatmap__empty--2col]="false"
                      [class.p-seatmap__empty--3col]="false"
                      [class.p-seatmap__empty--4col]="false"
                    ></div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- 右翼 -->
              <span
                *ngIf="row?.rowFacilities?.wings?.right"
                class="p-seatmap__wing-right"
                [class.p-seatmap__wing-right--start]="isRightWingsStart(deck, j)"
                ><span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.wing' | staticMsg }}"></span
              ></span>

              <!-- 右非常口 -->
              <span
                *ngIf="row?.rowFacilities?.emergencyExits?.right"
                class="p-seatmap__emergency-exit p-seatmap__emergency-exit--right"
                ><span class="u-visually-hidden" innerHTML="{{ 'reader.seatmap.exit' | staticMsg }}"></span
              ></span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
